import { Sprout, Copy } from "lucide-react";

/** Small badge distinct from the DocBlock Cross badge.
 *  Seed Derived → sand-toned outlined; Clone → slate outlined. */
export default function PropagationBadge({ type, size = "sm", testid, className = "" }) {
  if (type !== "seed_derived" && type !== "clone") return null;
  const isSeed = type === "seed_derived";
  const label = isSeed ? "Seed Derived" : "Clone";
  const Icon = isSeed ? Sprout : Copy;
  const palette = isSeed
    ? "border-[#D4A373] text-[#8A5A2B] bg-[#FBF3E8]"
    : "border-[#5A6B7A] text-[#324A5F] bg-[#EEF2F6]";
  const height = size === "xs" ? "h-5" : "h-6";
  const px = size === "xs" ? "px-1.5" : "px-2";
  const font = size === "xs" ? "text-[10px]" : "text-[11px]";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border ${palette} ${height} ${px} ${font} font-medium ${className}`}
      data-testid={testid || `propagation-badge-${type}`}
    >
      <Icon size={size === "xs" ? 10 : 11} />
      {label}
    </span>
  );
}
